export const plus = () => (
  <path
    d="M12 5v14m-7-7h14"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
);
